import { configureStore } from '@reduxjs/toolkit';
import reducer from '../features/myProfileSlice';

const store = configureStore({ reducer });

export default store;
